import * as Joi from "joi";

export const LoginSchema = Joi.object({
  email: Joi.string()
    .email({ minDomainSegments: 2, tlds: { allow: ['com', 'net'] } })
    .required('Please provide your email'),
  password: Joi.string().required('Please provide you password')
}).options({ abortEarly: false });